import axios from "axios";
import { hrAdminDashboardApi } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

const authConfig = () => ({
    headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${getUserToken()}`,
    },
});

/**
 * Fetch HR admin dashboard data.
 * @param {string|null} startDate - "YYYY-MM-DD" or null for today
 * @param {string|null} endDate   - "YYYY-MM-DD" or null for today
 */
export const getHrAdminDashboard = async (startDate = null, endDate = null) => {
    let url = hrAdminDashboardApi;
    const params = [];
    if (startDate) params.push(`start_date=${startDate}`);
    if (endDate) params.push(`end_date=${endDate}`);
    if (params.length) url += `?${params.join("&")}`;
    return axios.get(url, authConfig());
};
